import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { translateCode } from '../utils/translate-code';

/** Translates a product condition code (`shared.productCondition.*`); unknown codes are returned as-is. */
@Pipe({
    name: 'isUsedConverter',
    standalone: false
})
export class IsUsedConverter implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(isUsed: string): string {
    return translateCode(this.translate, 'shared.productCondition', isUsed);
  }
}
